import React from 'react';

import style from './index.module.scss';

const InformationOfRegistrationInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Проверка регистрации на ЭТП ТЭК-Торг</h1>

    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Получить информацию о поставщике зарегистрирован он или нет в Секциях «ТЭК-Торг»
        </div>
        <div className={style.descriptionItem}>Узнать даты регистрации поставщика в Секциях «ТЭК-Тог»</div>
        <div className={style.descriptionItem}>
          Проанализировать объем закупок ЭТП «ТЭК-Торг», в которых принимал участие поставщик
        </div>
      </div>
    </div>
  </>
);

export default InformationOfRegistrationInfo;
